export default __webpack_public_path__ + "locales/uk-UA/Webhooks.json?hash=8071c93bb2305085af6f2116672be486";